module.exports = __webpack_public_path__ + "static/team-3-477af5891f53389bb536b1a2c96b4fb8.jpg";